export default __webpack_public_path__ + "c2042b17c9eb0c5503d59316e4b8eb73.otf";